import React, { FC } from "react";
import { StyledGridItem } from "./gridItem.styled";
import InfoIcon from "@mui/icons-material/Info";

interface DashboardProps {
  children: JSX.Element[] | JSX.Element;
  title: string;
  showInfoIcon?: boolean;
}

const Dashboard: FC<DashboardProps> = ({ children, title, showInfoIcon }) => (
  <StyledGridItem elevation={1}>
    { title && 
      <div className="grid-item-heading">
        <h2 className="grid-item-title">{title}</h2>
        {showInfoIcon && <InfoIcon className="info-icon" />}
      </div>
    }
    {children}
  </StyledGridItem>
);

export default Dashboard;
